import { render, staticRenderFns } from "./boxDashboardButton.vue?vue&type=template&id=6f4d775f&scoped=true&"
import script from "./boxDashboardButton.vue?vue&type=script&lang=js&"
export * from "./boxDashboardButton.vue?vue&type=script&lang=js&"
import style0 from "./boxDashboardButton.vue?vue&type=style&index=0&id=6f4d775f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d775f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VIcon})
